export default __webpack_public_path__ + "static/badge-collected-23dc82198922a7c5799badd847895529.png";